import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { map, range } from 'lodash';
import { connect } from '../../reducers/index';

import './styles.css';

const ProgressBar = props => {
  const { progressStage, type } = props;
  let totalCount = null;
  if (type === 'identify') {
    totalCount = 6;
  } else if (type === 'assist') {
    totalCount = 8;
  } else {
    totalCount = 9;
  }
  const totalProgress = range(1, totalCount + 1);
  const progressContent = map(totalProgress, (number, index) => {
    if (number <= progressStage) {
      return <span className={`progress-${type}-finished`} key={index} />;
    } else {
      return <span className="progress-pending" key={index} />;
    }
  });

  return (
    <Row className="text-center">
      <Col xs={12} md={10} mdOffset={1}>
        <p>Progress</p>
        <div
          className="module-progress-bar"
          aria-label={`Progress Bar: ${progressStage} of ${totalCount} completed`}
        >
          {progressContent}
        </div>
      </Col>
    </Row>
  );
};

ProgressBar.propTypes = {
  progressStage: PropTypes.number
};

ProgressBar.defaultProps = {
  progressStage: null
};

export default connect.role(ProgressBar);



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.jsx